import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';

/**
 * The address a booking is fulfilled at — "Delivery Address" for medicine, "Collection Address"
 * for diagnostics. Shared so the two booking snapshots cannot drift apart.
 *
 * `address` is the API's `delivery_address` object, produced by `_resolve_delivery_address` on the
 * backend and identical in shape across both services:
 *   { address_line_1, address_line_2, landmark, city, state, pincode, address_type }
 *
 * Renders nothing at all when there is no address — a booking whose subscriber has none on file
 * gets no empty section, and the caller does not need its own guard.
 */
const DeliveryAddressCard = ({ address, title = 'Delivery Address', className = '' }) => {
  if (!address) return null;

  const line = [
    address.address_line_1,
    address.address_line_2,
    address.landmark,
    [address.city, address.state].filter(Boolean).join(', '),
    address.pincode,
  ].filter(Boolean).join(', ');

  return (
    <div className={className}>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2 text-sm font-semibold text-gray-700">
          <FaMapMarkerAlt className="text-blue-600 w-4 h-4" />
          {title}
        </div>
        {address.address_type && (
          <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-blue-50 text-blue-700 border border-blue-200 capitalize">
            {address.address_type}
          </span>
        )}
      </div>
      <div className="text-sm text-gray-900 leading-relaxed bg-gray-50 border border-gray-200 rounded-lg p-3">
        {line || 'N/A'}
      </div>
    </div>
  );
};

export default DeliveryAddressCard;
